import { Heading } from '@react-spectrum/s2';
import { style } from '@react-spectrum/s2/style' with { type: 'macro' };
import { memo, type ReactNode } from 'react';

import { cn } from '@/utils/cn';

interface SectionProps {
	title: string;
	children: ReactNode;
	className?: string;
}

export const Section = memo(function Section({
	title,
	children,
	className,
}: SectionProps) {
	return (
		<div className={cn('glass-card-sm flex flex-col gap-5 p-6', className)}>
			<div className="flex items-center gap-3">
				<Heading
					level={3}
					styles={style({
						font: 'title',
						fontWeight: 'bold',
						color: 'title',
						fontSize: 'title',
					})}
				>
					{title}
				</Heading>
				<div
					className="h-px flex-1 bg-gradient-to-r from-[var(--glass-border)]
						to-transparent"
				/>
			</div>
			<div className="flex flex-col gap-4">{children}</div>
		</div>
	);
});
